import { library } from "@fortawesome/fontawesome-svg-core";
import { 
  faBars,
  faClock,
  faPhoneAlt,
  faEnvelope,
  faMapMarkerAlt,
  faSearch,
  faPlus,
  faMinus,
  faShoppingCart,
  faTimes,
  faArrowLeft
}from "@fortawesome/free-solid-svg-icons";

library.add(
  faBars, 
  faClock, 
  faPhoneAlt, 
  faEnvelope, 
  faMapMarkerAlt, 
  faSearch, 
  faPlus, 
  faMinus, 
  faShoppingCart, 
  faTimes,
  faArrowLeft
);